<template>
  <div class="container" :class="{'active':isShow}">
       <div class="title">
            请选择行政部门
       </div>
       <better-scroll class="box" :scrollY="true">
           <div class="wrapper">
               <div class="item" v-for="(item,index) in proList" :key="index" @click="slectItem(item,index)">
                    <span>{{item.fullName}}</span>
                    <span v-if="item.select">√</span>
                </div>
           </div>

       </better-scroll>
       <div class="f_bottom">
            <span @click="cancel">取消选择</span>
            <span @click="send">确定选择</span>
       </div>
  </div>
</template>
<script>
    import betterScroll from '../../../../components/base/betterScroll'
    export default {
        components: {
            'better-scroll': betterScroll
        },
        props: {
            proList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data () {
            return {
                selectList: [],
                isShow: false
            }
        },
        created () {
            this.isShow = false;
        },
        methods: {
            hideBox () {
                this.isShow = false;
            },
            showBox () {
                this.isShow = true;
            },
            slectItem (item, index) {
                this.$set(this.proList[index], 'select', !this.proList[index].select);
            },
            cancel () {
                this.selectList = [];
                if (this.proList.length > 0) {
                    this.proList.map((item, index) => {
                        this.$set(this.proList[index], 'select', false)
                    })
                }
                this.$emit('getSelect', this.selectList);
                this.isShow = false;
            },
            send () {
                this.selectList = [];
                if (this.proList.length > 0) {
                    this.proList.map((item, index) => {
                        if (item.select === true) {
                            this.selectList.push(item);
                        }
                    })
                }
                this.$emit('getSelect', this.selectList);
                this.isShow = false;
            }
        }
    }
</script>
<style lang="less" scoped>
.container{
    width:100%;
    height:100%;
    position: fixed;;
    left:0;
    top:0;
    background-color:#fff;
    z-index: 9999;
    transform: translateY(-101%);
    transition: all 0.5s ease-in-out;
    .title{
        width:100%;
        height:50px;
        text-align: center;
        line-height: 50px;
        font-size:16px;
        border-bottom: 1px solid #efefef;
    }
    .box{
        width:100%;
        position: fixed;
        top:50px;
        bottom: 48px;
        // padding:0 16px;
        // box-sizing: border-box;
        // padding-bottom: 48px;
        .wrapper{
            width:100%;
            .item{
                width:100%;
                padding:20px 16px;
                border-bottom: 1px solid #efefef;
                display: flex;
                display: -webkit-flex;
                box-sizing: border-box;
                font-size: 14px;
                color:#aaa;
                justify-content: space-between;
                align-items: center;
                span:nth-child(2){
                    display: inline-block;
                    width:18px;
                    height:18px;
                    border:1px solid #ccc;
                    background-color: @base-color;
                    text-align: center;
                    line-height: 18px;
                    color:#fff;
                    border-radius: 50%;
                }
            }
        }
    }
    .f_bottom{
        width:100%;
        height:48px;
        position: fixed;
        left:0;
        bottom:0;
        border-top:1px solid #efefef;
        display:flex;
        display: -webkit-flex;
        justify-content:space-between;
        align-items: center;

        span{
            width:50%;
            height:48px;
            line-height: 48px;
            display: inline-block;
            text-align: center;
            font-size:16px;
            background-color:#fff;
        }
        span:nth-child(2){
            background-color: @base-color;
            color:#fff;
        }
    }
}
.active{
    transform: translateY(0%);
}
</style>
